import React from "react"
import styled from "styled-components"
import { LinkBox } from "Components"

import { media, mixins, FooterSection, FullWrapper, Text } from "Styles"
import { theme } from "Theme"

import { IconLinkedin, IconInstagram, IconTwitter } from "./icons"
import Config from "Data"
import { Link } from "gatsby"

const Wrapper = styled.div`
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const StyledFullWrapper = styled(FullWrapper)`
  margin: 0;
  padding: 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 0 1rem;
    margin: 0 auto;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Content = styled.section`
  line-height: initial;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  ${mixins.flexBetween};
  flex-direction: column;
  & + section {
    border-top: 1px solid #aaa;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const SocialContainer = styled.div`
  ${media.desktop`order: 1;`};
`

const SocialItemList = styled.ul`
  ${mixins.flexBetween};
  margin: 0;
  li {
    margin: 0;
  }
`

const SocialLink = styled.span`
  margin: 0;
  padding: ${theme.padding};
  svg {
    width: 18px;
    height: 18px;
  }
`

const FooterBottomBlock = styled.div`
  margin: 0;
  padding: 0 ${theme.padding};
  display: flex;
  flex-direction: column;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    padding: ${theme.padding};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const FooterSimple = ({ transparentFooter }) => (
  <FooterSection id="footer" transparentFooter={transparentFooter}>
    <Wrapper>
      <StyledFullWrapper>
        <Content>
          <FooterBottomBlock>
            <Text>
              © {new Date().getFullYear()} {Config.contact.legalName}. All rights reserved.
            </Text>
            <Link to={"/privacy/"} title={`Privacy Policy`} data-gtm={`Footer | Privacy Policy`}>
              Privacy Policy
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link to={"/terms/"} title={`Terms of use`} data-gtm={`Footer | Terms of use`}>
              Terms of use
            </Link>
          </FooterBottomBlock>
          <FooterBottomBlock>
            <SocialContainer>
              <SocialItemList>
                {Config.socialMedia &&
                  Config.socialMedia.map(
                    ({ name, url }, i) =>
                      url && (
                        <li key={i}>
                          <LinkBox
                            to={url}
                            alt={`${Config.brand} on ${name}`}
                            title={`${Config.brand} on ${name}`}
                            target="_blank"
                            track={"Footer Social Links"}
                            rel="nofollow noopener noreferrer"
                            aria-label={name}>
                            <SocialLink>
                              {(() => {
                                switch (name) {
                                  case "Linkedin":
                                    return <IconLinkedin />
                                  case "Instagram":
                                    return <IconInstagram />
                                  case "Twitter":
                                    return <IconTwitter />
                                  default:
                                    return ""
                                }
                              })()}
                            </SocialLink>
                          </LinkBox>
                        </li>
                      )
                  )}
              </SocialItemList>
            </SocialContainer>
          </FooterBottomBlock>
        </Content>
      </StyledFullWrapper>
    </Wrapper>
  </FooterSection>
)

export default FooterSimple
